import {
    FETCH_SYNC_INFO_SUCCESS,
    FETCH_SYNC_INFO_ERROR
  } from '../actions/sync-info'
  
  const initialState = {
    items: null,
    error: null,
    loading: false
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case FETCH_SYNC_INFO_SUCCESS:
        return { ...state, items: (action||{}).data }
      case FETCH_SYNC_INFO_ERROR:
        return { ...state, error: action.message }
      default:
        return state
    }
  }